export default __webpack_public_path__ + "static/media/cardBlurredLayout.b2e745f8.png";